export default {
	search: {
		title: 'Find Your Crew Ride',
		subtitle: 'Enter your flight number to find your transportation',
		placeholder: 'Enter Flight Number',
		button: 'Find Ride',
		slug: 'Crew Business is Our Business',
		imgAlt: '654 Global Logo',
		searchErrors: {
			empty: 'Flight number cannot be empty',
			noValidLinkOrExpired: 'This link has expired or is invalid. Please contact your dispatcher for a new access link.',
		},
	},
	tripCard: {
		imgAlt: 'Location Icon',
	},
	tripStatus: {
		'new': 'Planned',
		'in-route': 'In Route',
		'done': 'Done',
		'canceled': 'Canceled',
	},
	api: {
		error: 'An error occurred. Please try again later.',
	},
	noResults: {
		title: 'We are sorry, but there are currently no rides planned for flight #<flightNumber>.',
		button: 'Look For another Flight',
		vehicleNotFound: 'Vehicle Was Not Found. Please Try Again',
	},
	tripHeader: {
		distance: 'Distance',
		duration: 'Duration',
		pta: 'PTA',
		kilometers: 'km',
		minutesAbbreviation: 'min',
	},
	tripPoint: {
		drop: 'Drop Off',
		pick: 'Pickup',
	},
	tripDetailInfo: {
		contactDispatcher: 'Call dispatch',
		locateVehicle: 'Locate driver',
		rate: 'Rate trip & driver',
		curbSide: 'Ready for pickup',
	},
	curbSidePopup: {
		message: 'The driver has been notified.',
		errorMessage: 'Could not send the curb-side request. Please try again.',
		okButton: 'OK',
		confirmMessage: 'Are you sure you want to notify the driver that you are physically curb-side?',
		confirmButton: 'Yes',
		cancelButton: 'Cancel',
	},
	driverCard: {
		driverDetails: 'Driver Details',
	},
	driverLocation: {
		title: 'Locate Vehicle',
	},
	rateTrip: {
		title: 'Your Feedback',
		form: {
			name: {
				label: 'Name',
				placeholder: 'Enter your name',
			},
			phone: {
				label: 'Phone',
				placeholder: 'Enter your phone',
			},
			contactMe: {
				label: 'Contact me',
			},
			rating: {
				label: 'Rating',
			},
			feedback: {
				label: 'Feedback',
				placeholder: 'Write your feedback here',
			},
			validation: {
				required: 'is required',
				min: 'must be at least ${min}',
				max: 'must be at most ${max}',
				maxLength: 'must be at most ${max} characters',
				ratingOrFeedback: 'Please provide a rating or feedback',
			},
			submitButton: 'Submit',
			error: 'An error occurred while submitting your feedback. Please try again later.',
		},
	},
	thankYouFeedback: {
		title: 'Thank You For Your Feedback',
		button: 'Back to Trip',
	},
};
